import React from "react";
import { connect } from "react-redux";
import MMPLShipCard from "./MMPLShipCard";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getMMPLIHMSearchlist,
  getMMPLMDocSearchlist,
  getMMPLPoValidationSearchlist,
  getMMPLShipCount,
  getMMPLShipSearch,
  getMMPLShortClosedSearchlist,
  addMMPLShortClosedSearchlist,
  putMMPLShortClosedSearchlist,
  getMMPLShipPendingSearchlist,
  mailCollectMDocSDoc,
  holdMailMdocSdoc,
  restorePo,
} from "../Actions/MMPLDashboardAPI";
import MMPLPendingTaskPOValidation from "./MMPLPendingTaskPOValidation";
import MMPLPendingTaskMDocSDoc from "./MMPLPendingTaskMDocSDoc";
import MMPLPendingTaskIHM from "./MMPLPendingTaskIHM";
import MMPLShortClosed from "./MMPLShortClosed";
import DatePicker from "react-datepicker";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import API from "../helpers/api";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import PO from "../Asset/PO.svg";
import MyPendingTask from "../Asset/MyPendingTask.svg";
import Awaiting from "../Asset/Awaiting.svg";
import ShipPendingTask from "../Asset/ShipPendingTask.svg";
import IHMPending from "../Asset/IHMPending.svg";
import IHMUpdated from "../Asset/IHMUpdated.svg";
import shortClosed from "../Asset/shortClosed.svg";
import Ship from "../Asset/Ship.svg";
import clear from "../Asset/clear.svg";

class MMPLDashboardShip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      PageNo: 1,
      PgSize: 25,
      shipId: 0,
      TaskType: "poconfirmation",
      shipName: "",
      poValidationShipName: "",
      poNumber: "",
      mDocShipName: "",
      IHMShipName: "",
      ShortClosedShipName: "",
      poDescription: "",
      PODateFrom: "",
      PODateTo: "",
      itemDescription: "",
      supplierName: "",
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      PendingTaskPO: true,
      PendingTaskMDocSDoc: false,
      isShipsPendingTask: false,
      PendingTaskIHM: false,
      isIhmUpdate2: false,
      TotalShip: false,
      PurchaseOrders: false,
      ShortClosed: false,
      posuccess: false,
    };
    this.SearchIHMShips = this.SearchIHMShips.bind(this);
    this.SearchPoValidationShips = this.SearchPoValidationShips.bind(this);
    this.SearchmDocShips = this.SearchmDocShips.bind(this);
    this.SearchShortClosedShips = this.SearchShortClosedShips.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.SearchPendingtask = this.SearchPendingtask.bind(this);
    this.ClearPurchaseOrderSearchField =
      this.ClearPurchaseOrderSearchField.bind(this);
    this.ClearPoSearchField = this.ClearPoSearchField.bind(this);
    this.ClearMdocSearchField = this.ClearMdocSearchField.bind(this);
    this.ClearIHMSearchField = this.ClearIHMSearchField.bind(this);
    this.ClearShortClosedSearchField =
      this.ClearShortClosedSearchField.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePOInputChange = this.handlePOInputChange.bind(this);
    this.handleMdocInputChange = this.handleMdocInputChange.bind(this);
    this.handleIHMInputChange = this.handleIHMInputChange.bind(this);
    this.handleShortClosedInputChange =
      this.handleShortClosedInputChange.bind(this);
    this.handleShipInputChange = this.handleShipInputChange.bind(this);
    this.handlePONumberInputChange = this.handlePONumberInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const { dispatch, match, POSuccess } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Dashboard" });
    if (match.params.id) {
      this.state.shipId = match.params.id;
      if (POSuccess) {
        dispatch(getMMPLPoValidationSearchlist(POSuccess, POSuccess.PageNo));
      } else {
        dispatch(getMMPLPoValidationSearchlist(this.state, this.state.PageNo));
      }
      dispatch(getMMPLShipCount(this.state.shipId));
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, POSuccess } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    if (POSuccess && !prevState.posuccess && POSuccess !== "") {
    
      prevState.poValidationShipName = POSuccess.poValidationShipName;
      prevState.mDocShipName = POSuccess.mDocShipName;
      prevState.IHMShipName = POSuccess.IHMShipName;
      prevState.ShortClosedShipName = POSuccess.ShortClosedShipName;
      prevState.poNumber = POSuccess.poNumber;
      prevState.poDescription = POSuccess.poDescription;
      prevState.supplierName = POSuccess.supplierName;
      prevState.itemDescription = POSuccess.itemDescription;
      prevState.PODateFrom = POSuccess.PODateFrom;
      prevState.PODateTo = POSuccess.PODateTo;
      prevState.PendingTaskPO = POSuccess.PendingTaskPO;
      prevState.PurchaseOrders = POSuccess.PurchaseOrders;
      prevState.isShipsPendingTask = POSuccess.isShipsPendingTask;
      prevState.PendingTaskMDocSDoc = POSuccess.PendingTaskMDocSDoc;
      prevState.PendingTaskIHM = POSuccess.PendingTaskIHM;
      prevState.isIhmUpdate2 = POSuccess.isIhmUpdate2;
      prevState.ShortClosed = POSuccess.ShortClosed;
      prevState.TaskType = POSuccess.TaskType;
      prevState.posuccess = true;
      // dispatch({ type: "POSuccess", data: ""});
    }
  }

  getShipDetails(action) {
    const { dispatch, match, history } = this.props;
    if (action === 1) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poNumber = "";
      this.state.poDescription = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      this.state.posuccess = false;
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      dispatch({ type: "POSuccess", data: "" });
      this.state.TaskType = "poconfirmation";
      this.state.PendingTaskPO = true;
      this.state.PendingTaskMDocSDoc = false;
      this.state.PendingTaskIHM = false;
      this.state.isIhmUpdate2 = false;
      this.state.isShipsPendingTask = false;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = false;
      this.state.ShortClosed = false;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      this.setState({});
      window.scrollTo(0, 0);
      dispatch(getMMPLPoValidationSearchlist(this.state, this.state.PageNo));
    } else if (action === 2) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poDescription = "";
      this.state.poNumber = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      this.state.TaskType = "collectmdocsdoc";
      this.state.posuccess = false;
      this.state.PendingTaskPO = false;
      this.state.PendingTaskMDocSDoc = true;
      this.state.PendingTaskIHM = false;
      this.state.isIhmUpdate2 = false;
      this.state.isShipsPendingTask = false;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = false;
      this.state.ShortClosed = false;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      dispatch({ type: "POSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLMDocSearchlist(this.state, this.state.PageNo));
    } else if (action === 3) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poNumber = "";
      this.state.poDescription = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      this.state.TaskType = "ihmpart1";
      this.state.posuccess = false;
      this.state.PendingTaskPO = false;
      this.state.PendingTaskMDocSDoc = false;
      this.state.isShipsPendingTask = false;
      this.state.PendingTaskIHM = true;
      this.state.isIhmUpdate2 = false;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = false;
      this.state.ShortClosed = false;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      dispatch({ type: "POSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
    } else if (action === 4) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poNumber = "";
      this.state.poDescription = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      dispatch({ type: "PurchaseOrders", data: false });
      dispatch({ type: "POSuccess", data: "" });
      this.state.TaskType = "purchaseorders";
      this.state.posuccess = false;
      this.state.PendingTaskPO = false;
      this.state.PendingTaskMDocSDoc = false;
      this.state.PendingTaskIHM = false;
      this.state.isIhmUpdate2 = false;
      this.state.isShipsPendingTask = false;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = true;
      this.state.ShortClosed = false;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLPoValidationSearchlist(this.state, this.state.PageNo));
    } else if (action === 5) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poNumber = "";
      this.state.poDescription = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      this.state.TaskType = "shortClosed";
      this.state.posuccess = false;
      this.state.PendingTaskPO = false;
      this.state.PendingTaskMDocSDoc = false;
      this.state.isShipsPendingTask = false;
      this.state.PendingTaskIHM = false;
      this.state.isIhmUpdate2 = false;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = false;
      this.state.ShortClosed = true;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      dispatch({ type: "POSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLShortClosedSearchlist(this.state, this.state.PageNo));
    } else if (action === 6) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poNumber = "";
      this.state.poDescription = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      this.state.TaskType = "shipspendingtask";
      this.state.posuccess = false;
      this.state.PendingTaskPO = false;
      this.state.PendingTaskMDocSDoc = false;
      this.state.PendingTaskIHM = false;
      this.state.isIhmUpdate2 = false;
      this.state.isShipsPendingTask = true;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = false;
      this.state.ShortClosed = false;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      dispatch({ type: "POSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLShipPendingSearchlist(this.state, this.state.PageNo));
    } else if (action === 7) {
      this.state.poValidationShipName = "";
      this.state.mDocShipName = "";
      this.state.IHMShipName = "";
      this.state.ShortClosedShipName = "";
      this.state.poNumber = "";
      this.state.poDescription = "";
      this.state.itemDescription = "";
      this.state.supplierName = "";
      this.state.PODateFrom = "";
      this.state.PODateTo = "";
      this.state.TaskType = "ihmupdate2";
      this.state.posuccess = false;
      this.state.PendingTaskPO = false;
      this.state.PendingTaskMDocSDoc = false;
      this.state.PendingTaskIHM = false;
      this.state.isIhmUpdate2 = true;
      this.state.isShipsPendingTask = false;
      this.state.TotalShip = false;
      this.state.PurchaseOrders = false;
      this.state.ShortClosed = false;
      this.state.fromDatePickerIsOpen = false;
      this.state.toDatePickerIsOpen = false;
      dispatch({ type: "POSuccess", data: "" });
      this.setState({});
      window.scrollTo(0, document.body.scrollHeight);
      dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
    } else {
      dispatch({ type: "Staff", data: false });
      dispatch({ type: "Shipment Library", data: false });
      dispatch({ type: "ShipRole", data: "MMPL" });
      // dispatch({ type: "ShipDetails", data: item });
      dispatch({ type: "ShowShipView", data: true });
      localStorage.setItem("shipId", match.params.id);
      history.push(`/Home/Ship/${match.params.id}/Tasks`);
      // dispatch({ type: "MMPLSidePanCollectDocs", data: false });
      // this.setState({
      //     PendingTaskPO: false,
      //     PendingTaskMDocSDoc: false,
      //     PendingTaskIHM: false,
      //     PurchaseOrders: false,
      //     ShortClosed: false,
      //     fromDatePickerIsOpen: false,
      //     toDatePickerIsOpen: false,
      //     TotalShip: true
      // });
      // window.scrollTo(0, document.body.scrollHeight);
      // dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    }
    this.setState({ showClientDetails: false, filterclientDetails: false });
  }

  getClientDetails() {
    this.setState({ showClientDetails: true, filterShiplist: false });
  }

  SearchPendingtask() {
    this.setState({
      showPendingTask: true,
    });
  }

  ClearPurchaseOrderSearchField() {
    this.state.poValidationShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "purchaseorders";
    this.props.dispatch(
      getMMPLPoValidationSearchlist(this.state, this.state.PageNo)
    );
    this.setState({});
  }

  ClearPoSearchField() {
    this.state.poValidationShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "poconfirmation";
    this.props.dispatch(
      getMMPLPoValidationSearchlist(this.state, this.state.PageNo)
    );
    this.setState({});
  }

  ClearMdocSearchField() {
    this.state.mDocShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "collectmdocsdoc";
    this.props.dispatch(getMMPLMDocSearchlist(this.state, this.state.PageNo));
    this.setState({});
  }

  ClearIHMSearchField() {
    this.state.IHMShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "ihmpart1";
    this.props.dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
    this.setState({});
  }

  ClearShortClosedSearchField() {
    this.state.ShortClosedShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "shortClosed";
    this.props.dispatch(
      getMMPLShortClosedSearchlist(this.state, this.state.PageNo)
    );
    this.setState({});
  }

  ClearShipSearchField() {
    this.state.shipName = "";
    this.props.dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  handlePOInputChange(e) {
    this.state.poValidationShipName = e.target.value;
    this.setState({});
  }

  handleMdocInputChange(e) {
    this.state.mDocShipName = e.target.value;
    this.setState({});
  }

  handleIHMInputChange(e) {
    this.state.IHMShipName = e.target.value;
    this.setState({});
  }

  handleShortClosedInputChange(e) {
    this.state.ShortClosedShipName = e.target.value;
    this.setState({});
  }

  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    this.setState({});
  }

  handlePONumberInputChange(e) {
    this.state.poNumber = e.target.value;
    this.setState({});
  }

  handleFromDateChange(date) {
    this.state.PODateFrom = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.PODateFrom
    ) {
      this.state.PODateTo = Moment(new Date(Date.parse(date))).format(
        "YYYY-MM-DD"
      );
    } else {
      swal("Error!", "To date must be greater than from date ", "warning");
    }
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  // handlePODateChange(date) {
  //   this.state.poDate = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
  //   this.setState({
  //     SelectedPODate: date,
  //     poDatePickerIsOpen: false
  //   })
  // }

  // openPODatePicker() {
  //   this.setState({
  //     poDatePickerIsOpen: !this.state.poDatePickerIsOpen,
  //   });
  // };

  SearchPoValidationShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLPoValidationSearchlist(this.state, PgNo));
  }

  SearchPoShip(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLPoValidationSearchlist(this.state, PgNo));
  }

  SearchShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearch(this.state, PgNo));
  }

  SearchmDocShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLMDocSearchlist(this.state, PgNo));
  }

  SearchIHMShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLIHMSearchlist(this.state, PgNo));
  }

  SearchShortClosedShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShortClosedSearchlist(this.state, PgNo));
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "POSuccess", data: "" });
  };

  confirmAll = (item) => {
    const { dispatch } = this.props;
    this.state.posuccess = false;
    this.setState({});
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      isShortClosed: true,
    };
    dispatch(addMMPLShortClosedSearchlist(data, this.state));
  };

  //   undoShortClosed = (item) => {
  //     const { dispatch } = this.props;
  //     this.state.posuccess = false;
  //     let data = {
  //       purchaseOrderId: item.purchaseOrderId,
  //       isShortClosed: false
  //     }
  //     dispatch(putMMPLShortClosedSearchlist(data, this.state));
  //   };

  sendMail = (item) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      sentReminderMail: true,
      userMail: user.email,
    };
    this.props.dispatch(mailCollectMDocSDoc(data, this.state));
  };

  HoldMail = (item) => {
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      hold: item.isOnHold ? false : true,
    };
    this.props.dispatch(holdMailMdocSdoc(data, this.state));
  };
  revertPoItem = (shipId, poid) => {
    const { dispatch } = this.props;

    confirmAlert({
      message: "Are you sure want to revert this PO ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let url = `${API.RevertPo}` + poid;
            let url1 = url.replace(/\u200B/g, "");
        
            axios
              .put(url1)
              .then((response) => {
                console.log("tooSuceess");
                window.scrollTo(0, document.body.scrollHeight);
                dispatch(getMMPLShipCount(this.state.shipId));
                dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
                toast.success("Po Revert successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => {});
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const {
      shipMMPLInfo,
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCount,
      MMPLShipList,
      poSearchResult,
      mDocSearchResults,
      IHMSearchResults,
      ShortClosedSearchResults,
      shipPendingResult,
    } = this.props;
    const {
      PendingTaskPO,
      PendingTaskMDocSDoc,
      PendingTaskIHM,
      isIhmUpdate2,
      TotalShip,
      PurchaseOrders,
      ShortClosed,
      isShipsPendingTask,
    } = this.state;
  
    return (
      <div className="full-height pt-3">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mb-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
        </button>
        <div className="row px-2">
        <div className="col-lg-1 col-md-3 col-sm-6 p-1 pr-2 mb-4 " style={{ minWidth: "12.5%" }}>
            <div
              className={`${PurchaseOrders ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
             onClick={() => this.getShipDetails(4)}
            >
              <img src={PO} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `} style={{
                  marginTop: 10, color: "#F77F00"
                }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.pOs : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                Purchase Orders
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2 mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${PendingTaskPO ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              // style={{ height: "100%" }}
              onClick={() => this.getShipDetails(1)}
            >
              <img src={MyPendingTask} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#D62828" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.poValidation : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                My Pending Tasks - PO Validation
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1 col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${PendingTaskMDocSDoc ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(2)}
            >
              <img src={Awaiting} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#F77F00" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.collectMdocSdoc : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor `}
              >
                Awaiting MD & SDoC
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isShipsPendingTask ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(6)}
            >
              <img src={ShipPendingTask} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#D62828" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={
                    shipMMPLCount
                      ? shipMMPLCount.shipsPendingTask
                        ? shipMMPLCount.shipsPendingTask
                        : 0
                      : 0
                  }
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                Ships Pending Task
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${PendingTaskIHM ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(3)}
            >
              <img src={IHMPending} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#F77F00" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.ihmPart1 : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                IHM Part 1 - Pending to be Updated
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${isIhmUpdate2 ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(7)}
            >
              <img src={IHMUpdated} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "}`}
                style={{ marginTop: 10, color: "#C5D86D" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.ihmUpdate2 : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                IHM Part 1 - Updated
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${ShortClosed ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails(5)}
            >
              <img src={shortClosed} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#86CD82" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.shortClosed : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                {" "}
                Short Closed - PO's
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
          <div className="col-lg-1  col-md-3 col-sm-6 p-1 pr-2  mb-4" style={{ minWidth: "12.5%" }} >
            <div
              className={`${TotalShip ? "active-card " : "card-box "
                }card card-selector pl-4 pr-2 py-3 card-count`}
              style={{ height: "100%" }}
              onClick={() => this.getShipDetails("noAction")}
            >
              <img src={Ship} width={24} height={24} />
              <div
                className={`${MMPLSidePanCollectDocs ? "f-2 " : " "} `}
                style={{ marginTop: 10, color: "#685044" }}
              >
                <CountUp
                  start={0}
                  className="po-color"
                  end={shipMMPLCount ? shipMMPLCount.totalShips : 0}
                  duration={2.0}
                  separator=","
                />
              </div>
              <div
                className={`${MMPLSidePanCollectDocs ? "f-1 " : " "
                  } mt-1 po-bcolor`}
              >
                Ship
              </div>
            </div>
            <div className="card-count-shadow"></div>
          </div>
        </div>
        {this.state.PurchaseOrders ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Purchase Orders
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handlePOInputChange(e)}
                                                    value={this.state.poValidationShipName}
                                                ></input>
                                            </div> */}
                      <div className="col-lg-3">
                        <label className="form-label">PO Number</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poNumber"
                          placeholder="PO Number"
                          onChange={(e) => this.handlePONumberInputChange(e)}
                          value={this.state.poNumber}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poDescription"
                          placeholder="PO Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.poDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Supplier Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="supplierName"
                          placeholder="Supplier Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.supplierName}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Item Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="itemDescription"
                          placeholder="Item Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.itemDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date From</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.PODateFrom}
                            className="form-control date-picker"
                            placeholder="PO Date From"
                            name="POFromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date To</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.PODateTo}
                            type="text"
                            placeholder="PO Date To"
                            className="form-control date-picker"
                            name="POToDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchPoShip(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearPurchaseOrderSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {poSearchResult ? (
              <div id="textbody">
                <MMPLPendingTaskPOValidation
                  arraylist={poSearchResult.data}
                  pageSize={
                    poSearchResult.pagination.pageSize
                      ? poSearchResult.pagination.pageSize
                      : 0
                  }
                  totalRecords={
                    poSearchResult.pagination.totalcount
                      ? poSearchResult.pagination.totalcount
                      : 0
                  }
                  setUpdatedState={(value) => this.SearchPoShip(value)}
                  PO={PurchaseOrders}
                  confirmAll={(item) => this.confirmAll(item)}
                />
              </div>
            ) : null}
          </>
        ) : null}
        {this.state.PendingTaskPO ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        My Pending Tasks - PO Validation
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handlePOInputChange(e)}
                                                    value={this.state.poValidationShipName}
                                                ></input>
                                            </div> */}
                      <div className="col-lg-3">
                        <label className="form-label">PO Number</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poNumber"
                          placeholder="PO Number"
                          onChange={(e) => this.handlePONumberInputChange(e)}
                          value={this.state.poNumber}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poDescription"
                          placeholder="PO Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.poDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Supplier Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="supplierName"
                          placeholder="Supplier Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.supplierName}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Item Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="itemDescription"
                          placeholder="Item Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.itemDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date From</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.PODateFrom}
                            className="form-control date-picker"
                            placeholder="PO Date From"
                            name="POFromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date To</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.PODateTo}
                            type="text"
                            placeholder="PO Date To"
                            className="form-control date-picker"
                            name="POToDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchPoValidationShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearPoSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {poSearchResult ? (
              <div id="textbody">
                <MMPLPendingTaskPOValidation
                  arraylist={poSearchResult?.data}
                  pageSize={
                    poSearchResult?.pagination?.pageSize
                      ? poSearchResult?.pagination?.pageSize
                      : 0
                  }
                  totalRecords={
                    poSearchResult?.pagination?.totalcount
                      ? poSearchResult?.pagination?.totalcount
                      : 0
                  }
                  setUpdatedState={(value) =>
                    this.SearchPoValidationShips(value)
                  }
                />
              </div>
            ) : null}
          </>
        ) : null}
        {this.state.isShipsPendingTask ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Ships Pending Tasks
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handlePOInputChange(e)}
                                                    value={this.state.poValidationShipName}
                                                ></input>
                                            </div> */}
                      <div className="col-lg-3">
                        <label className="form-label">PO Number</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poNumber"
                          placeholder="PO Number"
                          onChange={(e) => this.handlePONumberInputChange(e)}
                          value={this.state.poNumber}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poDescription"
                          placeholder="PO Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.poDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Supplier Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="supplierName"
                          placeholder="Supplier Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.supplierName}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Item Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="itemDescription"
                          placeholder="Item Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.itemDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date From</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.PODateFrom}
                            className="form-control date-picker"
                            placeholder="PO Date From"
                            name="POFromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date To</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.PODateTo}
                            type="text"
                            placeholder="PO Date To"
                            className="form-control date-picker"
                            name="POToDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchPoValidationShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearPoSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {poSearchResult ? (
              <div id="textbody">
                <MMPLPendingTaskPOValidation
                  arraylist={shipPendingResult?.data ?? []}
                  pageSize={
                    shipPendingResult?.pagination.pageSize
                      ? shipPendingResult.pagination.pageSize
                      : 0
                  }
                  totalRecords={
                    shipPendingResult?.pagination.totalcount
                      ? shipPendingResult.pagination.totalcount
                      : 0
                  }
                  shipPending={isShipsPendingTask}
                  setUpdatedState={(value) =>
                    this.SearchPoValidationShips(value)
                  }
                />
              </div>
            ) : null}
          </>
        ) : null}
        {this.state.PendingTaskMDocSDoc ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Awaiting MD & SDoC
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handleMdocInputChange(e)}
                                                    value={this.state.mDocShipName}
                                                ></input>
                                            </div> */}
                      <div className="col-lg-3">
                        <label className="form-label">PO Number</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poNumber"
                          placeholder="PO Number"
                          onChange={(e) => this.handlePONumberInputChange(e)}
                          value={this.state.poNumber}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poDescription"
                          placeholder="PO Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.poDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Supplier Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="supplierName"
                          placeholder="Supplier Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.supplierName}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Item Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="itemDescription"
                          placeholder="Item Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.itemDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date From</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.PODateFrom}
                            className="form-control date-picker"
                            placeholder="PO Date From"
                            name="POFromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date To</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.PODateTo}
                            type="text"
                            placeholder="PO Date To"
                            className="form-control date-picker"
                            name="POToDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchmDocShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearMdocSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {mDocSearchResults ? (
              <MMPLPendingTaskMDocSDoc
                arraylist={mDocSearchResults.data}
                pageSize={
                  mDocSearchResults.pagination
                    ? mDocSearchResults.pagination.pageSize
                    : 0
                }
                totalRecords={
                  mDocSearchResults.pagination.totalcount
                    ? mDocSearchResults.pagination.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchmDocShips(value)}
                sendMail={(item) => this.sendMail(item)}
                HoldMail={(item) => this.HoldMail(item)}
              />
            ) : null}
          </>
        ) : null}
        {this.state.PendingTaskIHM || this.state.isIhmUpdate2 ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        My Pending Tasks - IHM Part 1 Update
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handleIHMInputChange(e)}
                                                    value={this.state.IHMShipName}
                                                ></input>
                                            </div> */}
                      <div className="col-lg-3">
                        <label className="form-label">PO Number</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poNumber"
                          placeholder="PO Number"
                          onChange={(e) => this.handlePONumberInputChange(e)}
                          value={this.state.poNumber}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poDescription"
                          placeholder="PO Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.poDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Supplier Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="supplierName"
                          placeholder="Supplier Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.supplierName}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Item Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="itemDescription"
                          placeholder="Item Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.itemDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date From</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.PODateFrom}
                            className="form-control date-picker"
                            placeholder="PO Date From"
                            name="POFromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date To</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.PODateTo}
                            type="text"
                            placeholder="PO Date To"
                            className="form-control date-picker"
                            name="POToDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchIHMShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearIHMSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            {IHMSearchResults ? (
              <MMPLPendingTaskIHM
                arraylist={IHMSearchResults.data}
                pageSize={
                  IHMSearchResults.pagination.pageSize
                    ? IHMSearchResults.pagination.pageSize
                    : 0
                }
                totalRecords={
                  IHMSearchResults.pagination.totalcount
                    ? IHMSearchResults.pagination.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchIHMShips(value)}
                revertPoItem={this.revertPoItem}
                isViewOnly={isIhmUpdate2}
              />
            ) : null}
          </>
        ) : null}
        {this.state.ShortClosed ? (
          <>
            <div className="row my-3">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header m-auto"
                    style={{ backgroundColor: "white" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Short Closed - PO's
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row" style={{ paddingBottom: "12px" }}>
                      {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handleShortClosedInputChange(e)}
                                                    value={this.state.ShortClosedShipName}
                                                ></input>
                                            </div> */}
                      <div className="col-lg-3">
                        <label className="form-label">PO Number</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poNumber"
                          placeholder="PO Number"
                          onChange={(e) => this.handlePONumberInputChange(e)}
                          value={this.state.poNumber}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="poDescription"
                          placeholder="PO Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.poDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Supplier Name</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="supplierName"
                          placeholder="Supplier Name"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.supplierName}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">Item Description</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="itemDescription"
                          placeholder="Item Description"
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.itemDescription}
                        ></input>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date From</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            type="text"
                            value={this.state.PODateFrom}
                            className="form-control date-picker"
                            placeholder="PO Date From"
                            name="POFromDate"
                          ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker}
                          >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <label className="form-label">PO Date To</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"
                        >
                          <input
                            value={this.state.PODateTo}
                            type="text"
                            placeholder="PO Date To"
                            className="form-control date-picker"
                            name="POToDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date"
                          />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}
                            >
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="mt-3 search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchShortClosedShips(1)}
                          >
                            {" "}
                            Search{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearShortClosedSearchField()}
                          >
                            {" "}
                            Clear{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {ShortClosedSearchResults ? (
              <MMPLShortClosed
                arraylist={ShortClosedSearchResults.data}
                pageSize={
                  ShortClosedSearchResults.pagination.pageSize
                    ? ShortClosedSearchResults.pagination.pageSize
                    : 0
                }
                totalRecords={
                  ShortClosedSearchResults.pagination.totalcount
                    ? ShortClosedSearchResults.pagination.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchShortClosedShips(value)}
                // undoShortClosed={(item) => this.undoShortClosed(item)}
              />
            ) : null}
          </>
        ) : null}
        {/* {this.state.TotalShip ? (
                    <>
                        <div className="row my-3">
                            <div className="col-lg-12">
                                <div className="panel-box">
                                    <div className="card MM-card-header m-auto" style={{ backgroundColor: "white" }}>
                                        <div className="card-body">
                                            <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>All Ships</h5>
                                        </div>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row" style={{ paddingBottom: '12px' }}>
                                            <div className="col-lg-6">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handleShipInputChange(e)}
                                                    value={this.state.shipName}
                                                ></input>
                                            </div>

                                            <div className="col-lg-6">
                                                <label className="form-label"></label>
                                                <br></br>
                                                <div className="mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                    <button
                                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                        type="submit"
                                                        onClick={() => this.SearchShips(1)}
                                                    >
                                                        {" "}Search{" "}
                                                    </button>
                                                    <button
                                                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                        type="button"
                                                        onClick={() => this.ClearShipSearchField()}
                                                    >
                                                        {" "}Clear{" "}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {MMPLShipList ? (
                            <MMPLShipCard
                                arraylist={MMPLShipList.data}
                                pageSize={MMPLShipList.pagination.pageSize}
                                totalRecords={MMPLShipList.pagination.totalcount ? MMPLShipList.pagination.totalcount : 0}
                                setUpdatedState={(value) => this.SearchShips(value)}
                            />
                        ) : null}
                    </>
                ) : null} */}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    shipMMPLCount: state.MMPLDashboardReducer.ShipMMPLCount,
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipList,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    shipPendingResult: state.MMPLDashboardReducer.MMPLPOShipPendingResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    ShortClosedSearchResults:
      state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    POSuccess: state.MMPLDashboardReducer.POSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MMPLDashboardShip);
